import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import RedirectHelper from 'pages/RedirectHelper/RedirectHelper';
import VerifyAccess from 'navigation/VerifyAccess';

import 'react-quill/dist/quill.snow.css';

const Login = React.lazy(() => import('pages/LoginPage'));
const Logout = React.lazy(() => import('pages/LoginPage/LogoutPage'));
const Page500 = React.lazy(() => import('pages/PageError/Page500'));
const PreOrderAgreementPage = React.lazy(() => import('pages/PreOrderAgreement/PreOrderAgreementPage'));
const DeliveryAgreementPage = React.lazy(() => import('pages/DeliveryAgreement/DeliveryAgreementPage'));
const InvoiceInformationPage = React.lazy(() => import('pages/InvoiceInformation/InvoiceInformationPage'));
const SalesReturnAgreementPage = React.lazy(() => import('pages/SalesReturn/SalesReturnAgreementPage'));
const WarrantyTrackingPage = React.lazy(() => import('pages/WarrantyManagement/WarrantyTrackingPage'));

function AppRouter() {
  return (
    <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
      <React.Suspense fallback={null}>
        <RedirectHelper
          ref={(ref) => {
            ref && (window._$g.rdr = ref && ref.go);
          }}
        />
        <Switch>
          <Route exact path='/500/:error?' name={window._$g._('Page 500')} component={Page500} />
          <Route exact path='/login' name={window._$g._('Login Page')} component={Login} />
          <Route exact path='/logout' name={window._$g._('Logout Page')} component={Logout} />
          <Route exact path='/preorder-agreement/:token' component={PreOrderAgreementPage} />
          <Route exact path='/delivery-agreement/:token' component={DeliveryAgreementPage} />
          <Route exact path='/invoice-information/:token' component={InvoiceInformationPage} />
          <Route exact path='/sales-return-agreement/:token' component={SalesReturnAgreementPage} />
          <Route exact path='/warranty-tracking/:token' component={WarrantyTrackingPage} />
          <Route path='/' render={() => <VerifyAccess />} />
        </Switch>
      </React.Suspense>
    </BrowserRouter>
  );
}

export default AppRouter;
